var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavigationBar',{on:{"toggle-drawer":function($event){_vm.drawer = !_vm.drawer}}}),_c('Sidebar',{model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}}),_c('v-main',{staticClass:"main-bg"},[_c('v-container',{staticClass:"pa-6",attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('Notification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }